import React, { useMemo } from "react";
import { ContractSaleStatusDropdownProps } from "./types";
import { DropdownOption } from "../Dropdown/types";
import { getContractSaleStatusesAPI } from "services/api/fleet/vehicles/contracts/api";
import { ContractSaleStatus } from "services/api/fleet/vehicles/contracts/types";
import { Dropdown } from "../Dropdown";
import { getStatusCircleColor } from "./consts";
import { DropdownCacheKey, useDropdownCache } from "services/hooks/useDropdownCache";

const ContractSaleStatusDropdown: React.FC<ContractSaleStatusDropdownProps> = (
  props: ContractSaleStatusDropdownProps
) => {
  const {
    name,
    disabled,
    required,
    label,
    error,
    value,
    direction,
    width,
    height,
    placeholder,
    onChange,
  } = props;

  const { data } = useDropdownCache<ContractSaleStatus[]>(
    DropdownCacheKey.ContractSaleStatuses,
    getContractSaleStatusesAPI,
    30 * 60 * 1000
  );

  const statusOptions = useMemo<DropdownOption[]>(
    () =>
      (data ?? []).map((status) => ({
        value: status.id,
        text: (
          <div className="flex items-center gap-2">
            <span className={`w-2.5 h-2.5 rounded-full inline-block ${getStatusCircleColor(status.color)}`} />
            <span>{status.name}</span>
          </div>
        ),
      })),
    [data]
  );

  return (
    <Dropdown
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      value={value}
      direction={direction}
      width={width}
      height={height}
      options={statusOptions}
      onChange={onChange}
      error={error}
    />
  );
};

export default React.memo(ContractSaleStatusDropdown);
